import { ProductPricing } from 'lib/context/AffiliateContext';

export const defaultPricingData: ProductPricing[] = [
  {
    productId: '3',
    productDescription: 'Ensemble Entry Door',
    currency: 'USD',
    pricingSource: 'National',
    productPricing: [
      {
        minQty: 1,
        maxQty: 1,
        minPrice: 7004,
        maxPrice: 19622,
      },
      {
        minQty: 2,
        maxQty: 999999,
        minPrice: 5908,
        maxPrice: 13963,
      },
    ],
  },
  {
    productId: '3',
    productDescription: 'Ensemble Entry Door',
    currency: 'CAD',
    pricingSource: 'National',
    productPricing: [
      {
        minQty: 1,
        maxQty: 1,
        minPrice: 8600,
        maxPrice: 20303,
      },
    ],
  },
  {
    productId: '1',
    productDescription: 'Acclaim Window',
    currency: 'USD',
    pricingSource: 'National',
    productPricing: [
      {
        minQty: 1,
        maxQty: 3,
        minPrice: 2635,
        maxPrice: 6572,
      },
      {
        minQty: 4,
        maxQty: 7,
        minPrice: 2452,
        maxPrice: 4896,
      },
      {
        minQty: 8,
        maxQty: 999999,
        minPrice: 2339,
        maxPrice: 4427,
      },
    ],
  },
  {
    productId: '4',
    productDescription: 'AW Patio Door',
    currency: 'USD',
    pricingSource: 'National',
    productPricing: [
      {
        minQty: 1,
        maxQty: 1,
        minPrice: 6401,
        maxPrice: 15481,
      },
      {
        minQty: 2,
        maxQty: 999999,
        minPrice: 5226,
        maxPrice: 14957,
      },
    ],
  },
  {
    productId: '1',
    productDescription: 'Acclaim Window',
    currency: 'CAD',
    pricingSource: 'National',
    productPricing: [
      {
        minQty: 1,
        maxQty: 3,
        minPrice: 3525,
        maxPrice: 8649,
      },
      {
        minQty: 4,
        maxQty: 7,
        minPrice: 3278,
        maxPrice: 6920,
      },
      {
        minQty: 8,
        maxQty: 999999,
        minPrice: 3090,
        maxPrice: 6270,
      },
    ],
  },
  {
    productId: '4',
    productDescription: 'AW Patio Door',
    currency: 'CAD',
    pricingSource: 'National',
    productPricing: [
      {
        minQty: 1,
        maxQty: 1,
        minPrice: 8317,
        maxPrice: 14104,
      },
      {
        minQty: 2,
        maxQty: 999999,
        minPrice: 8089,
        maxPrice: 15919,
      },
    ],
  },
  {
    productId: '2',
    productDescription: 'Acclaim Impact Window',
    currency: 'USD',
    pricingSource: 'National',
    productPricing: [
      {
        minQty: 1,
        maxQty: 3,
        minPrice: 3912,
        maxPrice: 8621,
      },
      {
        minQty: 4,
        maxQty: 7,
        minPrice: 3633,
        maxPrice: 7234,
      },
      {
        minQty: 8,
        maxQty: 999999,
        minPrice: 3334,
        maxPrice: 6498,
      },
    ],
  },
];
